import React from 'react';

import {
    getUrlParams,
    createCookie,
} from '../helper';
import axios from "axios";

class OAuthAuthorize extends React.Component {

    componentDidMount() {

        const query = getUrlParams(this.props.location.search);

        const str = query.state ? query.state : '';

        const url = str.replace('-', '/');

        if (!query.scope.split(',').includes('activity:read_all')) {

            if (window.confirm('Ohne die Freigabe deiner privaten Aktivitäten kannst du leider keine Daten an die Bestenliste übermitteln.')) {

                return this.props.history.push(`/${url}`)

            }

        }

        axios.post(`/api/authorize`, {code: query.code})
            .then(response => {

                createCookie('access_token', response.data.access_token, response.data.expires_in / 60 / 60 / 24);

                return this.props.history.push(`/${url}`)

            })
            .catch(error => {

                if (window.confirm('Konnte nicht mit Strava verbinden.')) {

                    return this.props.history.push(`/${url}`)

                }

            })

    }

    render() {

        return <div>App Authorized</div>

    }

}

export default OAuthAuthorize;
